import React from "react";
import Typography from "@material-ui/core/Typography";
import { SubmitButton } from "../components/Buttons/SubmitButton";
import { useAuth0 } from "@auth0/auth0-react";
import Grid from "@material-ui/core/Grid";
import { Container } from "../components/Container";
import { REQUIRED_PERMISSIONS } from "../hooks/usePermissions";

const AccessDeniedPage: React.FC = () => {
  const { logout, user } = useAuth0();

  const handleLogout = () => {
    logout({ returnTo: window.location.origin });
  };

  return (
    <Container className="bg-black-900 h-screen flex items-center justify-center">
      <Grid container spacing={4} justify="center" alignItems="center" style={{ minHeight: "60vh" }}>
        <Grid item xs={12} md={8}>
          <div className="text-center">
            <Typography variant="h3" component="h1" gutterBottom style={{ color: "#f04e23", fontWeight: "bold" }}>
              Access Denied
            </Typography>
            <Typography variant="h6" component="p" gutterBottom style={{ marginTop: "1rem", color: "#666" }}>
              {user?.email ? `${user.email} ` : "Your account "}
              does not have permission to access this application.
            </Typography>
            <Typography variant="body1" component="p" style={{ marginTop: "1rem", color: "#999" }}>
              Access to this app requires the following permission:
            </Typography>
            <ul style={{ textAlign: "left", display: "inline-block", marginTop: "1rem", color: "#999" }}>
              {REQUIRED_PERMISSIONS.map((permission) => (
                <li key={permission}>{permission}</li>
              ))}
            </ul>
            <Typography variant="body1" component="p" style={{ marginTop: "1.5rem", color: "#999" }}>
              If you believe this is a mistake, please contact your administrator to have the appropriate permission
              assigned to your account.
            </Typography>
            <div className="mt-8 flex justify-center">
              <SubmitButton
                isSubmitting={false}
                isValid={true}
                handleSubmit={handleLogout}
                type="button"
                label="Log Out"
              />
            </div>
          </div>
        </Grid>
      </Grid>
    </Container>
  );
};

export default AccessDeniedPage;
